import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClickButton"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { actions } from '../../constants/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const EditRemindersButton = _ref => {
  let {
      onClickButton
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !buttonProps.disabled,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.invoiceActionsDropdown.tooltips.editRemindersDisabled.noUpcomingReminders"
    }),
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      onClick: () => onClickButton(actions.EDIT_REMINDERS),
      "data-test-id": "edit-reminders-btn"
    }, buttonProps, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.buttons.editReminders"
      })
    }), "edit-reminders-btn")
  });
};
export default EditRemindersButton;